import { useNavigate } from "react-router-dom";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/lib/i18n";
import { PageHead } from "@/pages/Services";
import { UrgentCallout } from "@/pages/Home";
import { IMG } from "@/lib/constants";
import { useSeo } from "@/lib/seo";

export default function HowItWorks() {
  const { t } = useI18n();
  const nav = useNavigate();
  useSeo(t("how.title"), t("how.note"));
  return (
    <div data-testid="how-page">
      <PageHead title={t("how.title")} img={IMG.electrician} />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <ol className="grid md:grid-cols-2 gap-4">
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <li key={n} className="lift flex gap-5 rounded-2xl bg-white border border-slate-200 p-6" data-testid={`how-step-${n}`}>
              <span className="font-mono text-3xl font-semibold text-teal-600">0{n}</span>
              <div><h2 className="font-semibold text-lg text-slate-900">{t(`how.s${n}t`)}</h2><p className="text-sm text-slate-500 mt-1 leading-relaxed">{t(`how.s${n}d`)}</p></div>
            </li>
          ))}
        </ol>
        <div className="mt-8 flex items-start gap-3 rounded-2xl bg-amber-50 border border-amber-200 p-5 text-sm text-amber-900" data-testid="response-time-note">
          <Clock className="h-5 w-5 shrink-0" />{t("how.note")}
        </div>
        <div className="mt-6"><UrgentCallout /></div>
        <Button size="lg" onClick={() => nav("/request")} className="mt-10 rounded-full bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold" data-testid="how-cta-btn">{t("hero.cta1")}</Button>
      </section>
    </div>
  );
}
